import React from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { firestoreConnect } from 'react-redux-firebase';
import { Redirect } from 'react-router-dom';
import * as ROUTES from '../../constants/routes';

const HomeLanding = (props) => {
    if (props.isSignedIn) {
        if (props.userAuth.emailVerified) {
            return null;
        } else {
            return <Redirect to={ROUTES.VERIFY_ACCOUNT} />;
        }
    } else {
        return <Redirect to={ROUTES.LANDING} />;
    }
}

const mapStateToProps = (state) => {
    // console.log("FIREBASE WITH PROFILE")
    // console.log(state.firebase)
    return {
        userAuth: state.firebase.auth,
        isSignedIn: !state.firebase.auth.isEmpty,
    }
}

export default compose(
    connect(mapStateToProps),
)(HomeLanding);
